import api from "../../api/api";

export default {
  state: {
      currentTopicStatus: "",
      createTopicBoardContextID: null,
      searchedTopics: [],
      advancedSearchTopics: [],
      advancedSearchPosts: [],
      currentTopicSearchId: null,
      currentPostSearchId: null,
  },
  mutations: {
    setCurrentTopicStatus(state, value) {
      state.currentTopicStatus = value;
    },
    setSearchedTopics(state, value){
      state.searchedTopics = value;
    },
    setCreateTopicBoardContextID(state, value) {
      state.createTopicBoardContextID = value;
    },
    setSearchedIdTopics(state, value) {
        state.currentTopicSearchId = value;
    },
    setSearchedIdPosts(state, value) {
        state.currentPostSearchId = value;
    },
    setAdvancedSearchedTopics(state, value) {
        state.advancedSearchTopics = value;
    },
    setAdvancedSearchedPosts(state, value) {
        state.advancedSearchPosts = value;
    }
  },
  actions: {
    currentTopicStatus: ({commit}, value) => {
      commit('setCurrentTopicStatus', value);
    },
    createTopicBoardContextID: ({commit}, value) => {
      commit('setCreateTopicBoardContextID', value);
    },
    search: ({commit}, value) => {
      api.get("/search", {
        params: {
          text: value
        }
      }).then((r) => {
        commit('setSearchedTopics', r.data);
      });
    },
    advancedSearch: ({commit}, par) => {
      api.post("/search/advanced", par).then((r) => {
        commit('setSearchedTopics', r.data);
      });
    }
  },
  getters: {
    currentTopicStatus: (state) => { return state.currentTopicStatus; },
    createTopicBoardContextID: (state) => { return state.createTopicBoardContextID; }
  },
  namespaced: false,
};